import { currentUserVar } from "@cache/cache";

const SidebarSyncingError = () => {
  const currentUser = currentUserVar();
  if (!currentUser.hasCalendarSyncError) {
    return null;
  }
  return (
    <div>
      <div className="bg-white text-base mt-4 rounded-lg border flex flex-col gap-2 justify-center items-center py-6">
        <div className="text-gray-800 font-medium">Error syncing calendar</div>
        <span className="text-sm text-gray-500">
          Please contact{" "}
          <a className="text-blue-500" href="mailto:hello@topicflow.com">
            support
          </a>
        </span>
      </div>
    </div>
  );
};
export default SidebarSyncingError;
